import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { AllergenIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
};

const AllergenThemedIcon = ({ className, width, height, theme }) => (
  <AllergenIcon className={className} width={width} height={height} fill={theme.color.allergens} />
);

AllergenThemedIcon.propTypes = propTypes;

export default withTheme(AllergenThemedIcon);
